import FiltersItemCondition from "./FiltersItemCondition";

export { FiltersItem as default };

/**
* Filters Item Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersItem {

  /**
   * Filter id
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  id;

  /**
   * Filter name
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  name;

  /**
   * Conditions combine
   *
   * @public
   *
   * @type {Number} 1 - All conditions | 2 - Any condition
   *
   * @since 7.0.0
   */
  combine;

  /**
   * Conditions list
   *
   * @public
   *
   * @type {Array<FiltersItemCondition>}
   *
   * @since 7.0.0
   */
  conditions = [];

  /**
   * Flags list
   *
   * @public
   *
   * @type {Object.<string, number>}
   *
   * @since 7.0.0
   */
  flags = [];

  /**
   * Action
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
   action;

  /**
   * Action value
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  action_value;

  /**
   * Defines if filter is enabled
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  enabled;

  /**
   * Creates and adds a new condition entity to the conditions list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {FiltersItemConditionEntity}
   */
  createCondition() {
    let condition = new FiltersItemCondition();
    this.conditions.push(condition);
    return condition;
  }

  /**
   * Adds a new condition entity to the conditions list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersListEntity} condition  condition
   *
   * @return {void}
   */
  addCondition(condition) {
    this.conditions.push(condition);
  }

  /**
   * Removes a condition entity from he conditions list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {number} index conditions index
   *
   * @return {void}
   */
  removeCondition(index) {
    this.conditions.splice(index, 1)
  }
}